
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/signup",
      function () {
        return require("private-next-pages/app/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/signup"])
      });
    }
  